module.exports = __webpack_public_path__ + "pSIbFAhLWaWz2Kf3O/agent-training-center_about_referral_manager.png";